import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getUnmatchedPayments } from './invoice-match-payments-data.reducer';
import { UnmatchedPaymentsWithClients } from './models/unmatched-payments-with-clients.model';
import { List } from 'immutable';
import { filter, map } from 'rxjs/operators';
import { UnmatchedTransaction } from './models/unmatched-transaction.model';
import { Client } from '../client-data/client.model';
import { UnmatchedPayment } from './models/unmatched-payment.model';

@Injectable()
export class InvoiceMatchPaymentsDataStore {
  unmatchedPaymentsWithClients$: Observable<UnmatchedPaymentsWithClients> = this._store.select(
    getUnmatchedPayments
  );

  constructor(private _store: Store<any>) {}

  getUnmatchedPaymentsWithClients() {
    return this.unmatchedPaymentsWithClients$;
  }

  /**
   * Convert the response from backend to a list of
   * UnmatchedPayment which is a better data structure
   * that we can consume
   */
  getUnmatchedPayments(): Observable<List<UnmatchedPayment>> {
    return this.unmatchedPaymentsWithClients$.pipe(
      filter(
        (payments: UnmatchedPaymentsWithClients) =>
          payments && payments.size > 0
      ),
      map((payments: UnmatchedPaymentsWithClients) =>
        payments.unmatchedTransactions
          .map((transaction: UnmatchedTransaction) => {
            if (!payments.clients) {
              // edge case
              return new UnmatchedPayment(transaction);
            }

            const paymentClient = payments.clients.find(
              (client: Client) => client.id === transaction.clientId
            );

            return new UnmatchedPayment({
              ...transaction.toJS(),
              client: paymentClient ? paymentClient.toJS() : null,
            });
          })
          .toList()
      )
    );
  }

  getUnmatchedPaymentById(guid: string): Observable<UnmatchedPayment> {
    return this.getUnmatchedPayments().pipe(
      map((unmatchedPayments: List<UnmatchedPayment>) =>
        unmatchedPayments.find(
          (payment: UnmatchedPayment) => payment.transactionGuid === guid
        )
      )
    );
  }

  getTotalUnmatchedAmount(currencyCode: string): Observable<number> {
    return this.unmatchedPaymentsWithClients$.pipe(
      filter(
        (payments: UnmatchedPaymentsWithClients) =>
          payments && payments.size > 0
      ),
      map((payments: UnmatchedPaymentsWithClients) =>
        payments.unmatchedTransactions.reduce(
          (acc, transaction: UnmatchedTransaction) => {
            if (currencyCode && transaction.currencyCode !== currencyCode) {
              return acc;
            }

            return acc + transaction.unmatchedAmount;
          },
          0
        )
      )
    );
  }
}
